import React from 'react';
import { parseISO, format } from 'date-fns';

interface DateProps {
  dateString?: string;
  className?: string;
}

function getDate(dateString: string) {
  try {
    const dateValue = parseISO(dateString);
    return format(dateValue, 'LLLL	d, yyyy');
  } catch (err) {
    return format(new Date(), 'LLLL	d, yyyy');
  }
}
export default function DateComponent({
  dateString = '',
  className,
}: DateProps) {
  const date = getDate(dateString);

  return (
    <time className={className} dateTime={dateString}>
      {date}
    </time>
  );
}
